import PropTypes from 'prop-types';

export const Location = PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
});

export const Match = PropTypes.shape({
    params: PropTypes.shape({
        paymentSessionId: PropTypes.string.isRequired
    }).isRequired
});

// https://github.com/remix-run/react-router/issues/6610
const element = typeof Element === 'undefined' ? function () {} : Element;

export const Ref = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({current: PropTypes.instanceOf(element)})
]);

export default {
    Location,
    Match,
    Ref
};
